import { mapPropertiesTeams } from 'app/utils/entities/match_data';
import { roundForDisplay } from 'app/utils/number';

type MapWinrateOpponentCsWithWinrate = MapWinrateOpponentCs & { winrate: number };

const getCsMapOpponentStats = (
  opponent1Stats: MapWinrateOpponentCsWithWinrate | undefined,
  opponent2Stats: MapWinrateOpponentCsWithWinrate | undefined
): StatLine<MapWinrateOpponentCsWithWinrate>[] => {
  const displayFunction = (value: number) =>
    roundForDisplay(0, '%')(value > 1 ? value : value * 100);
  // Sort properties in this array by wanted display order
  const properties: StatProperties<MapWinrateOpponentCsWithWinrate>[] = [
    { name: 'pick_rate', highlighted: 'max', displayFunction },
    { name: 'ban_rate', highlighted: 'max', displayFunction },
    { name: 'winrate', highlighted: 'max', displayFunction },
    { name: 't_winrate', highlighted: 'max', displayFunction },
    {
      name: 'ct_winrate',
      highlighted: 'max',
      displayFunction
    }
  ];
  return mapPropertiesTeams(properties, opponent1Stats, opponent2Stats);
};

export { getCsMapOpponentStats };
